import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: unknown) => {
        // Don't retry on auth or client errors
        const e = error as { status?: number };
        if (e?.status === 401 || e?.status === 403) return false;
        if (e?.status && e.status >= 400 && e.status < 500) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
      staleTime: 60_000,
      gcTime: 30 * 60_000,        // 30 min retention
    },
  },
});
